import { Wording } from '@/types';

export const ASTROLOGY_WORDING_LV: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditācijas',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ceļveži',
  components_header_text2: 'Emuārs',
  components_header_members: 'Biedri',
  hero_text: 'Izpētiet zvaigznes iekšā',
  hero_button_text: 'Sāciet šeit',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Visi rīki, kas nepieciešami kosmiskam ieskatam un sevis atklāšanai',
  components_ressources_span_text: 'Paplašiniet savu iekšējo pasauli, izmantojot apkopotu aplādes un rakstu sajaukumu. Neatkarīgi no tā, vai meklējat kosmisku ieskatu, skaidrību vai garīgu saskaņošanu, mūsu resursi palīdz jums praktiski un jēgpilni sazināties ar astroloģiju.',
  components_ressources_card_1_title: 'Dziļi niršana',
  components_ressources_card_1_text: 'Ienirstiet bagātīgā padziļināto aplādes kolekcijā, kas aptver astroloģiju, taro, kosmiskos arhetipus un garīgo izaugsmi, kas izstrādāta, lai paplašinātu jūsu izpratni un padziļinātu jūsu praksi.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Astroloģiski padomi un emuāra ieraksti sevis apziņai un dvēseles izaugsmei.',
  components_ressources_link: 'Izpētiet tālāk',
  components_notes_and_google_title_1: 'Astroloģiskie norādījumi',
  components_notes_and_google_title_2: 'Kosmiskā rutīna',
  components_notes_and_google_title_3: 'Pārdomas',
  components_review_google_text: 'Atsauksmes',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Mūsu aplāde',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Vairāk epizožu',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: 'Raksti un ieskati',
  text2_section_button_more: 'Ielādēt vairāk',
  components_text1_section_title: 'CEĻVEIDI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Skatīt visus ceļvežus',
  components_footer_text: 'Atmodini savu iekšējo kosmosu: tavs ceļš, tavas zvaigznes.',
  components_footer_info: 'Informācija',
  components_footer_registration_number: 'Reģistrācijas numurs',
  components_footer_legal: 'Juridisks',
  components_footer_terms: 'Noteikumi un nosacījumi',
  components_footer_privacy: 'Privātuma politika',
  button_load_more: 'Ielādēt vairāk',
  page_media_1_content_hero_text: 'Podcast epizodes',
  page_media_content_menu_foundations: 'Pamati',
  page_media_content_menu_spirituality: 'Garīgums',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psiholoģija',
  page_media_content_menu_trends: 'Tendences',
  page_media_2_content_hero_text: '2. mediji',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Mūsu emuārs',
  page_text2_section_title: 'Emuārs',
  page_text2_subheader_text: 'Raksti un ieskati',
  enter_email_title: 'Lūdzu, ievadiet savu e-pastu, lai turpinātu',
  enter_email_placeholder_email: 'E-pasts',
  enter_email_button_enter: 'Ievadiet',
  components_login_success_text: 'Pieteikšanās veiksmīga!',
  components_card_link_media_content: 'Klausieties tūlīt',
  components_card_link_text1_content: 'Skatīt rokasgrāmatu',
  components_card_link_text2_content: 'Skatīt rakstu',
  france: 'Francija',
  cyprus: 'Kipra',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditācija',
  page_media_content_menu_all: 'Visi',
};